export const BRAND_NAME = "Mera Startup";
export const BRAND_HANDLE = "MeraStartup";
export const BRAND_ALIASES = ["MeraStartup", "Mera Startup", "merastartup"];
export const ORG_DESCRIPTION =
  "Mera Startup (also written MeraStartup) is India's best Shopify alternative — an Indian ecommerce website builder with cart, UPI, COD, GST billing, SEO and an optional Android app, from ₹1999 per year.";
export const ORG_SLOGAN = "India's Best Shopify Alternative";
export const PLATFORM_LOGO_URL = "https://media.merastartup.in/platform/landing/48f99f97577741a5bc063161989edbd9.png";
const LEGACY_PLATFORM_LOGO_URLS = new Set([
  "https://media.merastartup.in/platform/landing/d3a51161ab394efa83ac6ef15c7cbeb4.png",
]);

export function platformLogoUrl(url) {
  const u = String(url || "").trim();
  if (!u || LEGACY_PLATFORM_LOGO_URLS.has(u)) return PLATFORM_LOGO_URL;
  return u;
}
export const FOUNDER_NAME = "Neel Varma";
export const FOUNDER_SAME_AS = [
  "https://www.instagram.com/neelv007/",
  "https://www.facebook.com/neelv007",
  "https://x.com/neelv007",
  "https://in.linkedin.com/in/neelv07",
];

function cleanUrls(urls) {
  const out = [];
  const seen = new Set();
  for (const raw of urls || []) {
    const u = String(raw || "").trim();
    if (!u || seen.has(u)) continue;
    seen.add(u);
    out.push(u);
  }
  return out;
}

export function personJsonLd(origin) {
  const base = (origin || "").replace(/\/+$/, "");
  return {
    "@context": "https://schema.org",
    "@type": "Person",
    "@id": base ? `${base}/company/founder#person` : undefined,
    name: FOUNDER_NAME,
    jobTitle: `Founder, ${BRAND_NAME}`,
    worksFor: base ? { "@id": `${base}/#organization` } : { "@type": "Organization", name: BRAND_NAME },
    sameAs: FOUNDER_SAME_AS,
    url: base ? `${base}/company/founder` : undefined,
  };
}

export function orgJsonLd(origin, logo, extraSameAs) {
  const base = (origin || "").replace(/\/+$/, "");
  const logoUrl = platformLogoUrl(logo);
  const sameAs = cleanUrls(extraSameAs);
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": base ? `${base}/#organization` : undefined,
    name: BRAND_NAME,
    alternateName: BRAND_ALIASES,
    url: base || undefined,
    description: ORG_DESCRIPTION,
    slogan: ORG_SLOGAN,
    logo: {
      "@type": "ImageObject",
      "@id": base ? `${base}/#logo` : undefined,
      url: logoUrl,
      contentUrl: logoUrl,
    },
    image: logoUrl,
    founder: {
      "@type": "Person",
      "@id": base ? `${base}/company/founder#person` : undefined,
      name: FOUNDER_NAME,
      jobTitle: "Founder",
      sameAs: FOUNDER_SAME_AS,
      url: base ? `${base}/company/founder` : undefined,
    },
    sameAs: sameAs.length ? sameAs : undefined,
    address: {
      "@type": "PostalAddress",
      streetAddress: "Raghuleela Mall, Kandivali West",
      addressLocality: "Mumbai",
      postalCode: "400067",
      addressCountry: "IN",
    },
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+91-9137287747",
      email: "merastartup@grocode.in",
      contactType: "customer support",
      areaServed: "IN",
      availableLanguage: ["en", "hi"],
    },
    areaServed: "IN",
    knowsAbout: [
      "Ecommerce website builder",
      "Shopify alternative India",
      "COD checkout",
      "UPI payments",
      "Android store app",
    ],
  };
}

export function websiteJsonLd(origin) {
  const base = (origin || "").replace(/\/+$/, "");
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": base ? `${base}/#website` : undefined,
    name: BRAND_NAME,
    alternateName: BRAND_ALIASES,
    url: base || undefined,
    description: ORG_DESCRIPTION,
    inLanguage: "en-IN",
    publisher: base ? { "@id": `${base}/#organization` } : { "@type": "Organization", name: BRAND_NAME },
  };
}

export function softwareAppJsonLd(origin) {
  const base = (origin || "").replace(/\/+$/, "");
  return {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: BRAND_NAME,
    alternateName: BRAND_ALIASES,
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web",
    url: base || undefined,
    description: ORG_DESCRIPTION,
    author: base ? { "@id": `${base}/#organization` } : { "@type": "Organization", name: BRAND_NAME },
    offers: { "@type": "Offer", price: "1999", priceCurrency: "INR" },
  };
}
